import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type MarketplaceAsset } from '@pkg/types';

interface MarketplaceOfferState {
    confirmedToken: MarketplaceAsset | null;
    pendingConfirmation: boolean;
    token: MarketplaceAsset | null;
}

interface MarketplaceOfferStore extends MarketplaceOfferState {
    addConfirmedToken: (token: MarketplaceAsset) => void;
    addToken: (token: MarketplaceAsset) => void;
    removeConfirmedToken: () => void;
    removeToken: () => void;
    setPendingConfirmation: (pending?: boolean) => void;
}

const initialState: MarketplaceOfferState = {
    confirmedToken: null,
    pendingConfirmation: false,
    token: null,
};

export const STORE_KEY_MARKETPLACE_OFFER = 'marketplace-offer-store';

export const useOfferStore = create<MarketplaceOfferStore>()(
    devtools(
        (set) => ({
            ...initialState,
            addConfirmedToken: (confirmedToken) => set({ confirmedToken }),
            addToken: (token) => set({ token }),
            removeConfirmedToken: () => set({ confirmedToken: null }),
            removeToken: () => set({ token: null }),
            setPendingConfirmation: (pending = false) =>
                set({
                    pendingConfirmation: pending,
                }),
        }),
        { name: STORE_KEY_MARKETPLACE_OFFER },
    ),
);
